// extracted by mini-css-extract-plugin
module.exports = {"header-margin":"FootPrintListHeader_header-margin__Qi4rs","button":"FootPrintListHeader_button__EwGL_"};